import { render } from "./CellcountBlock.vue?vue&type=template&id=ef607ed6&ts=true"
import script from "./CellcountBlock.vue?vue&type=script&lang=ts"
export * from "./CellcountBlock.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__